// URLs absolutas de la aplicacion.
//
// ┌─ POR QUE ESTE ARCHIVO EXISTE ────────────────────────────────────────────────┐
// │ El boton de recuperacion de Admin usaba `${window.location.origin}/login`    │
// │ como `redirectTo`, y eso es exactamente lo que lo rompio: si el navegador    │
// │ esta en localhost o en un preview de Vercel, el redirect apunta a un origen  │
// │ que Supabase NO tiene en su lista de Redirect URLs — y entonces Auth         │
// │ RECHAZA la peticion entera y NO MANDA NINGUN CORREO.                          │
// │                                                                              │
// │ El sintoma es cruel: el boton parece fallar sin motivo. Verificado en BD el   │
// │ 2026-08-04: `auth.users.recovery_sent_at` de la disenadora estaba en NULL —   │
// │ el correo nunca salio. No es que no llegara: nunca se envio.                  │
// │                                                                              │
// │ Por eso el destino de un enlace que viaja POR CORREO no puede depender de     │
// │ donde tenga abierto el navegador quien aprieta el boton.                      │
// └──────────────────────────────────────────────────────────────────────────────┘
//
// ⚠️ Quedan CINCO `window.location.origin` sueltos fuera de este archivo
// (`lib/emails.js` x3 y `lib/stripe.js` x2). NO se tocan aca a proposito: son
// enlaces de brief, brandkit y pago, cada uno con su propio comportamiento, y
// meterlos convertiria un arreglo de autenticacion en un barrido de URLs.

const PRODUCCION = 'https://app.feria.design';

// Solo se respeta el origen del navegador en desarrollo local. En cualquier otro
// lado —produccion, previews de Vercel, dominios alternos— manda la URL de
// produccion, que es la unica que esta declarada en Supabase.
function esLocal() {
  if (typeof window === 'undefined') return false;
  return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(window.location.origin);
}

export function appBaseUrl() {
  return esLocal() ? window.location.origin : PRODUCCION;
}

export const LOGIN_URL = `${appBaseUrl()}/login`;

// Destino del enlace de recuperacion. Cae en /login, donde `App.js` detecta
// `#type=recovery` y muestra el formulario de contrasena nueva.
export const RESET_REDIRECT_URL = LOGIN_URL;

// Destino del portal del cliente. Va DENTRO de correos, asi que no puede depender del
// origen del navegador de quien aprieta el boton — que es la razon entera de este archivo.
// Coincide con `DEFAULT_PORTAL_LOGIN_URL` de `_shared/client-access.ts`.
export const PORTAL_URL = `${appBaseUrl()}/portal`;
